import React from 'react';
import { useWalletAuth } from '../../context/WalletAuthContext';
import BulkFundWallets from '../../components/BulkFundWallets';
import { companyAdminAPI } from '../../lib/walletApi';
import { Send } from 'lucide-react';

export default function CompanyAdminFundWallets() {
  const { user } = useWalletAuth();
  const companyId = user?.company_id;

  if (!companyId) {
    return (
      <div className="text-center py-16 text-gray-400">
        <Send className="w-10 h-10 mx-auto mb-3 opacity-40" />
        <p className="text-sm">No company associated with your account</p>
      </div>
    );
  }

  return (
    <div className="space-y-5" data-testid="ca-fund-wallets-page">
      <div>
        <h1 className="text-xl font-bold text-gray-900">Fund Employee Wallets</h1>
        <p className="text-sm text-gray-500">Select employees and fund their wallets from the company balance</p>
      </div>
      <BulkFundWallets
        companyId={companyId}
        loadEmployees={(params) => companyAdminAPI.getFundingEmployees(params)}
        executeFunding={(data) => companyAdminAPI.executeBulkFunding({ ...data, company_id: companyId })}
      />
    </div>
  );
}
